import React, { FunctionComponent } from 'react';
import { LoadingSpinner } from '@noths/polaris-client-ribbons-design-system';

import { Button, ButtonProps } from 'src/components/atoms/Button';
import * as styles from './styles';

interface CTAButtonProps extends ButtonProps {
  isLoading?: boolean;
}

export const CTAButton: FunctionComponent<CTAButtonProps> = ({
  children,
  isLoading,
  ...buttonProps
}: CTAButtonProps) => {
  return (
    <Button css={styles.ctaButton} {...buttonProps}>
      {!isLoading && children}
      {isLoading && (
        <div>
          <LoadingSpinner />
        </div>
      )}
    </Button>
  );
};
